export function getStrapiUrl() {
  return process.env.VUE_APP_STRAPI_API_URL
    ? process.env.VUE_APP_STRAPI_API_URL
    : "";
}
